/**
 * Plan event keys.
 */
const PlanEvents = {
    /*
     * Plan item added.
     *
     * Payload: @type {code: "ENG 203", isSection: false, atpId: "20231"}
     */
    planItemAdded: "Plan.planItemAdded",

    /*
     * Plan item removed.
     *
     * Payload: @type {planItemId: planItemId}
     */
    planItemRemoved: "Plan.planItemRemoved",

    /*
     * Plan item updated (moved to different term)
     *
     * payload @type {planItemId: planItemId, code: courseCd, atpId: atpId}
     */
    planItemUpdated: "Plan.planItemUpdated",

    /*
     * Plan item type changed (from planned to backup or vice versa)
     *
     * payload @type {planItemId: planItemId, newType: type}
     */
    planItemTypeChanged: "Plan.planItemTypeChanged",

    /**
     * An adviser recommended planItem was added to plan
     *
     * Payload: @type {planItemId: planItemId}
     */
    recommendedPlanItemAccepted: "Plan.recommendedPlanItemAccepted",


    /*
     * Event indicating plan item add/remove/update error
     * (currently generated on non-401 planItem service errors)
     * 
     * payload @type {error: exception}
     */
    planItemError: "Plan.planItemError",

    /*
     * Event indicating user changed which planItem to add to plan
     * based on the schedule option generated
     *
     * payload @type {dirty: true/false, duplicateSecondary: true/false, selectedActivityCodes: ['COM 220 A', 'COM 220 AA']}
     */
    planItemSelectionUpdated: "Plan.planItemSelectionUpdated"

};
export default PlanEvents;